
import { computed, defineComponent } from 'vue'
import SwiperSquareItem from '@/components/SwiperSquareItem.vue'
import Title from '@/components/common/Title.vue'
export default defineComponent({
  name: 'g-image-list',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    subTitle: {
      type: String,
      required: true,
      default: ''
    },
    imageList: {
      type: Array,
      required: true,
      default: () => []
    },
    row: {
      type: Number,
      required: false,
      default: 2
    },
    adsList: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    Title,
    SwiperSquareItem
    // SquareItemFullImage
  },
  setup (props, context) {
    const adsListRef = computed(() => props.adsList)

    // 將資料分配到4個區塊中
    const dividedData = computed(() => {
      // 因為行銷需求只先開放兩個
      // const result: Array<any[]> = [[], [], [], []] // 指定陣列型別為 any[]
      const result: Array<any[]> = [[], []] // 指定陣列型別為 any[]
      props.adsList.forEach((item, index) => {
        result[index % result.length].push(item as any) // 依序將資料分配到不同的陣列
      })
      return result
    })
    return { adsListRef, dividedData }
  }
})
